"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasActiveUserSessionWithPagesRouter = exports.hasActiveUserSessionWithAppRouter = void 0;
const server_1 = require("aws-amplify/auth/server");
const hasActiveUserSessionWithAppRouter = async ({ request, runWithAmplifyServerContext, }) => {
    const dummyResponse = new Response();
    try {
        await runWithAmplifyServerContext({
            nextServerContext: { request, response: dummyResponse },
            operation(contextSpec) {
                return (0, server_1.getCurrentUser)(contextSpec);
            },
        });
        return true;
    }
    catch (_) {
        // `getCurrentUser()` throws if there is no valid token
        return false;
    }
};
exports.hasActiveUserSessionWithAppRouter = hasActiveUserSessionWithAppRouter;
const hasActiveUserSessionWithPagesRouter = async ({ request, response, runWithAmplifyServerContext, }) => {
    try {
        await runWithAmplifyServerContext({
            nextServerContext: { request, response },
            operation(contextSpec) {
                return (0, server_1.getCurrentUser)(contextSpec);
            },
        });
        return true;
    }
    catch (_) {
        // `getCurrentUser()` throws if there is no valid token
        return false;
    }
};
exports.hasActiveUserSessionWithPagesRouter = hasActiveUserSessionWithPagesRouter;
